import React from "react"
import { graphql } from "gatsby"

export const query = graphql`
  fragment PartnerFields on DatoCmsPartner {
    id
    model {
      apiKey
    }
    componentId: key
    title
    images: image {
      url(imgixParams: { w: "600" })
      alt
    }
  }
`

export interface PartnerProps extends Queries.PartnerFieldsFragment {
  variant?: "noheader" | "small" | "negative-top-margin"
}

const Partners = (props: PartnerProps) => {
  const title = props.title || ""
  const images = props.images ? props.images : []

  return (
    <section
      id={props.componentId}
      className={`c-partners o-row ${
        props.variant ? `-${props.variant}` : ""
      } `}
    >
      <h2 className="c-content-header">{title}</h2>
      <div className="o-wrapper u-flex u-space-evenly ">
        <div className="c-partners__container">
          {images.map(i => (
            <div className="c-partners__logo-container" key={i.url}>
              <img src={i.url} alt={i.alt || ""} />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Partners
